import { render, staticRenderFns } from "./accountMgt.vue?vue&type=template&id=768d56ee&scoped=true&"
import script from "./accountMgt.vue?vue&type=script&lang=js&"
export * from "./accountMgt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768d56ee",
  null
  
)

export default component.exports